import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const Shop = styled.img`
  width: 24px;
`;

const Layout = styled.div`
  display: flex;
  align-items: center;
`;

const Name = styled.div`
  display: flex;
  color: #535353;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-left: 12px;
  text-transform: capitalize;
`;

export const MenuFantasyNameTopBar = () => {
  const capitalizarPrimeraLetra = (texto) =>
    texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();

  const merchant = useSelector((state) => state.login.merchant);

  return (
    <>
      <Layout>
        <Shop src="shopHouse.svg" alt="shop" />
        <Name>{capitalizarPrimeraLetra(merchant.merchant_name || merchant.business_name)}</Name>
      </Layout>
    </>
  );
};

export default MenuFantasyNameTopBar;
